/**
   * Displays the color swatches based on the metafield called variants.color
   * which consists of all related product handles, excluding itself.
   */

const createSizedImageUrl = (src, width) => {
  if (typeof src !== "string" || !width) {
    return src;
  }
  const indexOfLastDot = src.lastIndexOf(".");
  const name = src.substr(0, indexOfLastDot);
  const extension = src.substr(indexOfLastDot);
  return `${name}_${width}x${extension}`;
};

const createSwatchSrcSet = (src) => {
  const transformedSrcSet = `${createSizedImageUrl(
  src,
  20
)} 1x, ${createSizedImageUrl(src, 40)} 2x`;
  return transformedSrcSet;
};

const retrieveProduct = (
  colorsElement,
  colorObj,
  retrieveType,
  productInfo,
  specificProductRelatedColors
) => {
  let colorHandle = colorObj.handle;
  let colorSwatch = "";
  let colorSwatchImage = "";
  let currentProductHandle = "";
  let formColors = "";

  if (retrieveType == "product") {
    currentProductHandle = document.querySelector('[data-prod-handle]').getAttribute('data-prod-handle');
    formColors = document.querySelector(".js-form-colors");
  } else {
    currentProductHandle = productInfo.dataset.productHandle;
    formColors = specificProductRelatedColors;
  }



  const colorHex = colorObj.metafields[0].color;
  // console.log('colorHex ', colorHex);
  const colorURL = colorObj.url;
  const colorId = "color--" + colorObj.id;
  const colorTitle = colorObj.color.toLowerCase();
  const colorPrice = colorObj.price;
  const colorComparePrice = colorObj.compare_at_price;
  const productId = colorObj.id;
  const productAvailability = colorObj.available;
  let productFeaturedImage = '';
  let productFlatLayImage = '';
  try {
    productFeaturedImage = colorObj.images[0].src;
    colorObj.images.forEach(img => {
      if (img.alt.includes('flatlay')) {
        productFlatLayImage = img.src;
      }
    });
  } catch (error) {
    return
  }

  const productHandle = colorObj.handle;
  const productFirstAvailableVariantId = colorObj.first_available_variant_id;
  let isActive = false;


  if (document.querySelector('[data-prod-id]').getAttribute('data-prod-id') == productId) {
    isActive = true;
  }

  // console.log('colorObj ', colorURL);

  // Get the color hexcode/image for swatches
  // Product image with alt 'swatch'

  colorObj.images.filter((img, index) => {
    colorSwatchImage = img.alt == "color_swatch" ? `${img.src}` : "";
    colorSwatch =
      img.alt == "color_swatch"
        ? `background-image: url('${createSizedImageUrl(
          img.src,
          50
        )}'); background-size: contain;`
        : "";

    if (productInfo || specificProductRelatedColors)
      colorSwatch = img.alt == "color_swatch" ? `${img.src}` : "";

    if (colorSwatch == "" && colorObj.images.length - 1 == index) {
      colorSwatch = `background-image: url(${img.src});`;
      colorSwatchImage = `${img.src}`;
    }
  });

  // console.log('colorSwatch ', colorSwatch);

  if (colorSwatch == "") {
    // Metafield hexcode - product.metafields.color.swatch
    colorSwatch = `background-color: ${colorHex};`;
  } else if (colorSwatch == "") {
    // Fallback to second half of title - don't result to this
    colorSwatch = `background-color: ${colorTitle};`;
  }

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let size = "";

  if (urlParams.get('size')) {
    size = `?size=${urlParams.get('size')}`
  }

  // console.log('productFeaturedImage ', productFeaturedImage);
  // Inserting the color swatches
  if (!productInfo || !specificProductRelatedColors) {
    colorsElement = `
    <button type="button" data-url="${colorURL}${size}" class="pdp--legacy-swatch__container pdp--legacy-swatch__btn js-pdp-color-swatch-button" data-active="${isActive}" tabindex="0" aria-label="Switch to ${colorTitle} Variant">
      <div data-url="${colorURL}${size}" data-product-id="${productId}" class="pdp--legacy-swatch__wrap large-down-hide" data-color-id="${colorId}" title="${colorTitle}">
        <span data-url="${colorURL}${size}" class="pdp--legacy-swatch" data-color-id="${colorId}" style="${colorSwatch}"></span>
      </div>
      <div class="pdp--legacy-swatch__wrap-mobile medium-up-hide">
        <img class="pdp--legacy-swatch__wrap-mobile-img" src="${!productFlatLayImage == '' ? productFlatLayImage : productFeaturedImage}"/>
      </div>
    </button>
  `;
  } else {
    // Collection + Related Sliders
    colorsElement = `
  <div class="swatch radio radio--color js-swatch">
    <button type="button" data-url="${colorURL}" class="swatch__url js-swatch-url" data-product-handle="${productHandle}">
      <span class="geturlfull ${
        currentProductHandle == colorHandle || productInfo == colorHandle
          ? "rq-border-color-boxes"
          : ""
      }">
        <img alt="" height="27px" width="27px" class="Image--lazyLoad" data-srcset="${createSwatchSrcSet(
          colorSwatch
        )}" class="swatch__image">
      </label>
    </button>
  </div>
`;
  }
  // console.log('colorsElement ', colorsElement);
  var divElement = document.createElement('div');
  divElement.classList.add('swatch-element');
  divElement.setAttribute('data-swatch-prod-available', productAvailability);
  if (window.theme.template == 'product' && window.innerWidth < 768) {
    divElement.classList.add('swiper-slide');
  }
  divElement.innerHTML = colorsElement;
  document.querySelector('.swatch-list').appendChild(divElement);

  if (colorObj.handle != "psycho-bunny-gift-box" && formColors) {
    // Add color DOM
    formColors.insertAdjacentHTML("beforeend", colorsElement);
  }

  const swatchContainer = document.querySelector(`button[data-url="${colorURL}${size}"]`);
  swatchContainer.addEventListener('click', (e) => {
    const { target } = e;
    let { url: path } = target.dataset;
    if (path.includes('?size')) {
      path = path.split('?size')[0];
    }

    const baseURL = window.location.href.split('/product')[0];
    const countryCode = window.GLBE_PARAMS.countryCode;

    fetch(`${baseURL}${path}?view=json`)
    .then((res) => res.json())
    .then((product) => {
      updateActiveSwatch(target);
      updateProductFormID(product);
      updateBrowserHistory(baseURL, path, product);
      updateSizes(product, path);
      updatePrice(product);
      updateGallery(product);
      updateColor(product);
      updateDescription(product);
      updateHiddenVars(product);
      updateYotpo(product, baseURL);
      updateHighlyRated();
      updateEmbroideryFunctionality(product);
      updateBadge(product);
    })
  });
};

/**
  * Update badge when switching colors
  */
const updateBadge = (product) => {
  const badgeImage = product.tags.filter((tag) => tag.includes('badge-img'));
  const badgeText = product.tags.filter((tag) => tag.includes('badge__'));
  const $textBadge = document.querySelector('.js-text-badge');
  const $imageBadge = document.querySelector('.js-image-badge');
  const $imageBadgeWrap = document.querySelector('.js-image-badge-wrap');

  // Hide all badges
  $imageBadgeWrap.classList.add('hide');
  $textBadge.classList.add('hide');

  if (badgeImage.length > 0) {
    // Show badge image
    const imgFile = badgeImage[0].split('badge-img__')[1];
    $imageBadge.src = imgFile;
    $imageBadgeWrap.classList.remove('hide');
  } else if (badgeText.length > 0) {
    // Show badge text
    const badge = badgeText[0].split('badge__')[1];
    // capitalize first letter of badge
    $textBadge.innerHTML = (badge.charAt(0).toUpperCase() + badge.slice(1)).replace(/-/g, ' ');
    $textBadge.classList.remove('hide');
  }
};

const updateEmbroideryFunctionality = (product) => {
  const $embroideryCustomizeButton = document.querySelector('.js-embroidery-button-wrapper');
  const $embroideryBadge = document.querySelector('.js-embroidery-badge');
  if (!$embroideryCustomizeButton) return;
  SDG.Product.embroideryFeeProductSelector = product.embroidery_fee_product_variant_id;

  if (product.enable_embroidery) {
    $embroideryCustomizeButton.classList.remove('hide');
  } else {
    $embroideryCustomizeButton.classList.add('hide');
  }
};

const updateActiveSwatch = ($activeSwatch) => {
  $previousSwatch = document.querySelector('.pdp--legacy-swatch__btn[data-active="true"]');
  $previousSwatch?.removeAttribute('data-active');
  $activeSwatch.setAttribute('data-active', 'true');
};


const updateProductFormID = ({first_available_variant_id: variantID}) => {
  const $productForm = document.querySelector('.product-form__var-input');
  $productForm.setAttribute('value', variantID);
}

const updateBrowserHistory = (baseURL, path, product) => {
  const productTitle = product.title.split(' - ')[0].toUpperCase();
  const title = product.page_title;
  document.title = title;
  const updatedURL = `${baseURL}${path}`;
  window.historyInitiated = true;
  window.history.pushState({ path }, title, updatedURL);
}

const updateSizes = ({ variants: sizes }, url) => {
  const $variantRadios = document.querySelector('variant-radios');
  $variantRadios.dataset.url = url
  const $radiosContainer = $variantRadios.querySelector('.product-form__input-items');
  const sectionId = $variantRadios.dataset.section;
  let inputsMarkup = '';
  sizes.forEach((size, index) => {
    const sizeInputMarkup = `
      <input type="radio" id="${sectionId}-${index}" data-variant-id="${size.id}" name="Size" value="${size.option2}" form="product-form-template--15078901383191__main" data-option-index="2" ${!size.available ? 'class="unavailable"' : ''}>
      <label class="size-value" data-value="${size.option2}" data-variant-id="${size.id}" data-option-index="2" for="${sectionId}-${index}" onclick="sizeClick(this)">
        ${size.option2}
      </label>
    `;
    inputsMarkup += sizeInputMarkup;
  })
  $radiosContainer.innerHTML = inputsMarkup;
}

const updateHiddenVars = (product) => {
  const $hiddenVars = document.querySelector('.hidden-vars');
  let variantsMarkup = '';
  product.variants.forEach((variant) => {
    const variantMarkup = `
      <div class="prod-var" data-option1="${variant.option1}" data-option2="${variant.option2}" data-option3="" data-var-id="${variant.id}"></div>
    `;
    variantsMarkup += variantMarkup;
  });
  $hiddenVars.innerHTML = variantsMarkup;
};

const updateColor = (product) => {
  const $color = document.querySelector('#colorValue');
  const colorOption = product.options_with_values.find((value) => value.name === 'Color');
  const { selected_value: colorValue } = colorOption;
  if ($color) {
    $color.innerHTML = colorValue;
  }
  const $formTitle = document.querySelector('.product-form__titles');
  if ($formTitle) {
    function titleCase(string){
      return string[0].toUpperCase() + string.slice(1).toLowerCase() + ' ';
    }
    const colorValues = product.color.split(' ');
    const capColorOption = colorValues.reduce((accumulator, currentValue) => accumulator + titleCase(currentValue),
    '')
    $formTitle.innerHTML = `<legend class="form__label">Color</legend> ${capColorOption.trim()}`;
  }
};

const updateYotpo = (product, baseURL) => {
  const $productReviews = document.querySelector('.js-product-reviews');
  $productReviews.dataset.prodId = product.id;
  $productReviews.dataset.prodAvailable = product.available;
  $productReviews.dataset.prodHandle = product.handle;
  const $yotpo = $productReviews.querySelector('.yotpo-main-widget')
  $yotpo.dataset.productId = product.id;
  $yotpo.dataset.name = product.title;
  $yotpo.dataset.url = `${baseURL}${product.url}`;
  $yotpo.dataset.imageUrl = product.featured_image;
  $yotpo.dataset.description = product.description;
  const api = new Yotpo.API(yotpo);
  api.refreshWidgets();
}

const updateDescription = ({ description }) => {
  const $description = document.querySelector('.js-description');
  if (description && $description) {
    $description.innerHTML = description;
  }
}

const updateHighlyRated = () => {
  setTimeout(() => {
    if (document.querySelectorAll('.yotpo-regular-box').length > 4 ) {
      $('.highly-rated').addClass('show-highly-rated');
    } else {
      $('.highly-rated').removeClass('show-highly-rated');
    }
  }, 3000);
}

const updateGallery = ({ images }) => {
  const gallery = document.querySelector('.product__media-list');
  const productModal = document.querySelector('.product-media-modal');
  const modalGallery = document.querySelector('.product-media-modal__content');
  let galleryMarkup = '';
  let modalGalleryMarkup = '';
  const dataModal = productModal.id;
  images.forEach((image) => {
    if (!image.alt.includes('color_swatch')) {
      const imageMarkup = `
        <li id="Slide-template--15078901383191__main-22226669830167" class="product__media-item grid__item slider__slide is-active" data-media-id="template--15078901383191__main-22226669830167">
        <noscript><div class="product__media media gradient global-media-settings" style="padding-top: ${(1/image.aspect_ratio)*100}%;">
          <img
            class="lazyload"
            data-srcset="
              ${image.src}&width=493 493w,
              ${image.src}&width=600 600w,
              ${image.src}&width=713 713w,
              ${image.src}&width=823 823w,
              ${image.src}&width=990 990w,
              ${image.src}&width=1100 1100w,
              ${image.src}&width=1206 1206w,
              ${image.src}&width=1346 1346w,
              ${image.src}&width=1426 1426w,
              ${image.src} 1500w
            "
            data-src="${image.src}&width=1946"
            data-sizes="auto"
            sizes="(min-width: 1300px) 660px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
            loading="lazy"
            width="973"
            height="1214"
            alt=""
          >
        </div></noscript>

        <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="#${dataModal}">
          <span class="product__media-icon motion-reduce" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path>
        </svg>
        </span>

        <div class="product__media media media--transparent gradient global-media-settings" style="padding-top: ${(1/image.aspect_ratio)*100}%;">
          <img class="lazyload" data-srcset="
              ${image.src}&amp;width=493 493w,
              ${image.src}&amp;width=600 600w,
              ${image.src}&amp;width=713 713w,
              ${image.src}&amp;width=823 823w,
              ${image.src}&amp;width=990 990w,
              ${image.src}&amp;width=1100 1100w,
              ${image.src}&amp;width=1206 1206w,
              ${image.src}&amp;width=1346 1346w,
              ${image.src}&amp;width=1426 1426w,
              ${image.src} 1500w
            " data-src="${image.src}&amp;width=350" data-sizes="auto" sizes="355px" loading="lazy" alt="" srcset="
              ${image.src}&amp;width=493 493w,
              ${image.src}&amp;width=600 600w,
              ${image.src}&amp;width=713 713w,
              ${image.src}&amp;width=823 823w,
              ${image.src}&amp;width=990 990w,
              ${image.src}&amp;width=1100 1100w,
              ${image.src}&amp;width=1206 1206w,
              ${image.src}&amp;width=1346 1346w,
              ${image.src}&amp;width=1426 1426w,
              ${image.src} 1500w
            " src="${image.src}&amp;width=350">
          </div>
          <button class="product__media-toggle" type="button" aria-haspopup="dialog" data-media-id="${image.id}">
            <span class="visually-hidden">
              Open media 1 in modal
            </span>
          </button>
        </modal-opener>
      </li>
    `;
    const modalImageMarkup = `
      <img
        class="global-media-settings global-media-settings--no-shadow lazyload"
        data-srcset="${image.src}&amp;width=550 550w,${image.src}&amp;width=1100 1100w,${image.src}&amp;width=1445 1445w,${image.src} 1500w"
        data-src="${image.src}&amp;width=1445" sizes="(min-width: 750px) calc(100vw - 22rem), 1100px" alt="MENS TURING GRAPHIC TEE - B6U313W1PC" width="1100" height="1372"
        data-media-id="${image.id}"
      >
    `;
    galleryMarkup += imageMarkup;
    modalGalleryMarkup += modalImageMarkup;
    }
  })
  gallery.innerHTML = galleryMarkup;
  modalGallery.innerHTML = modalGalleryMarkup;
  lazySizes.init()
}

const displayPercentOff = function displayPercentOff(compareAtPrice, price) {
  // Calculate the percentage saved
  const percentageSaved = Math.round(100 - ((price / compareAtPrice) * 100));
  return `${percentageSaved.toFixed(0)}% off`;
};

const updatePrice = ({ price, compare_at_price: comparePrice }) => {
  const $priceContainers = document.querySelectorAll('.pdp-section .price');
  $priceContainers.forEach(($priceContainer) => {
    const $prices = $priceContainer.querySelectorAll('.js-price');
    const $comparePrices = $priceContainer.querySelectorAll('.js-compare-price');
    const formattedPrice = formatMoney(price);
    const formattedComparePrice = formatMoney(comparePrice);
    const $comparePriceEl = $priceContainer.querySelector('.strikethrough-price-item.js-compare-price');
    const isSale = !!(comparePrice && price !== comparePrice);
    const $percentageOffBadge = document.querySelectorAll('.js-percentage-off-badge');
    if ($percentageOffBadge) {
      $percentageOffBadge.forEach(($badge) => {
        $badge.textContent = displayPercentOff(comparePrice, price);
      })
    }
    if ($prices) {
      $prices.forEach(($price) => {
        $price.textContent = formattedPrice;
      })
    }
    if ($comparePrices) {
      $comparePrices.forEach(($comparePrice) => {
        $comparePrice.textContent = formattedComparePrice;
      })
    }
    if (isSale) {
      if ($comparePriceEl) {
        $priceContainer.classList.add('price--on-sale');
        $comparePriceEl.classList.remove('hide');
      } else {
        const comparePriceMarkup = `
          <span class="strikethrough-price-item js-compare-price">
            ${formattedComparePrice}
          </span>
        `;
        $priceContainer.classList.add('price--on-sale');
        const $normalPriceContainers = $priceContainer.querySelectorAll('.js-price');
        $normalPriceContainers.forEach(($normalPriceContainer) => {
          $normalPriceContainer.insertAdjacentHTML('afterend', comparePriceMarkup);
        });
      }
    } else {
      $priceContainer?.classList.remove('price--on-sale');
      $comparePriceEl?.classList.add('hide');
    }
  });
}

const formatMoney = (cents) => {
  if (typeof cents == 'string') {
    cents = cents.replace('.','');
  }
  let currencySymbol = '';
  let withDecimalSeparator = true;
  let convertedPrice = cents;
  const { active: currency, rate }  = Shopify.currency;
  if (currency === 'USD' || currency === 'AUD' || currency === 'JMD' || currency === 'NZD' ) {
    currencySymbol = '$';
  } else if (currency === 'EUR') {
    currencySymbol = '€';
  } else if (currency === 'GBP') {
    currencySymbol = '£';
  } else if (currency === 'NOK') {
    currencySymbol = 'kr';
  } else if (currency === 'CHF') {
    currencySymbol = 'CHF';
  }

  if (currency === 'EUR' || currency === 'NOK') {
    withDecimalSeparator = false;
  }

  if (currency === 'NOK') {
   return  `${formatMoneyNumbers(cents, withDecimalSeparator)} ${currencySymbol}`;
  }  else {
    return `${currencySymbol}${formatMoneyNumbers(cents, withDecimalSeparator)}`;
  }
}

const formatMoneyNumbers = (cents, decimalSeparator) => {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  let value = '';

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  if (decimalSeparator) {
    value = formatWithDelimiters(cents, 2);
  } else {
    value = formatWithDelimiters(cents, 2, '.', ',');
  }

  return value;
};

window.addEventListener('popstate', () => {
  window.location.assign(window.location.pathname);
});

const colorToggle = () => {
  const allColorSelectors = [
    ...document.querySelectorAll(".js-form-colors .swatch label"),
  ];
  const colorTitle = document.querySelector(".js-color-name");

  allColorSelectors.forEach((color) => {
    // Hovering on the color swatches
    color.addEventListener("mouseover", (e) => {
      if (
        document.querySelector(".js-swatch input:checked + label").dataset
          .productId != color.dataset.productId
      ) {
        colorTitle.innerText = color.querySelector("span").textContent;
      }
    });

    // Hovering off the color swatches
    color.addEventListener("mouseout", (e) => {
      colorTitle.innerText = document.querySelector(
        ".js-swatch input:checked + label span"
      ).textContent;
    });
  });
};

const colorSwatchesInit = () => {
  const colorJSON = JSON.parse(color_handles);
  const currentProductHandle = document.querySelector('[data-prod-handle]').getAttribute('data-prod-handle');
  colorJSON.push(currentProductHandle);
  document.querySelector(".product-form__input-items");
  const formSelect = document.querySelector(".js-form-select");
  const productMediaShare = document.querySelector(".js-product-media-share");
  const productMediaImages = document.querySelector(
    ".js-social-media-image-share"
  );
  let colorsElement;
  let ajax_calls = [];
  let allColors = [];
  let sizeElementDOM = "";
  let selectElementDOM = "";
  let socialShareDOM = "";

  if (colorJSON.length < 2) {
    jQuery.ajaxSetup({ async: false });
    $.get(`/products/${currentProductHandle}?view=json`, (resp) => {
      let colorObj = JSON.parse(resp);
      retrieveProduct(colorsElement, colorObj, "product");
      document.dispatchEvent(new CustomEvent("swatches:loaded"));
    });
    return;
  }

  const promiseState = (p) =>
    p.then(
      (v) => ({ v, status: "fulfilled" }),
      (e) => ({ e, status: "rejected" })
    );
  colorJSON.forEach((handle) => {
    ajax_calls.push(
      $.get(`/products/${handle}?view=json`, (resp) => {
        let parsedContent;
        try {
          parsedContent = JSON.parse(resp);
        } catch {
          console.warn('not valid JSON');
          parsedContent = null;
        }
        if (parsedContent) {
          allColors.push(parsedContent);
        }
      }),
    );
  });

  Promise.all(ajax_calls.map(promiseState)).then(function () {
    // Sort all the colors alphabetically
    allColors.sort(function (a, b) {
      var colorA = a.color;
      var colorB = b.color;
      return colorA < colorB ? -1 : colorA > colorB ? 1 : 0;
    });

    // Loop through each color
    allColors.forEach((colorObj, index) => {
      // console.log('colorObj ', colorObj);
      const productId = colorObj.id;
      const colorId = "color--" + colorObj.id;
      const productHandle = colorObj.handle;
      const productTitle = colorObj.title;
      const productDescription = colorObj.description_strip;
      const productFeaturedImage = colorObj.featured_image;
      let isActive = false;

      retrieveProduct(colorsElement, colorObj, "product");

      // const productFetchRequest (e) => {
      //   console.log('e.dataset.url', e.dataset.url);
      // }

      // Skip if it's the same product as the original
      if (document.querySelector('[data-prod-id]').getAttribute('data-prod-id') == productId) {
        isActive = true;
        return;
      }

      // Generating the images
      // Get the rest of the Images
      let imageContent = "";
      let imageDots = "";
      let slideshowImages = "";
      let slideShowImageContent = "";


      colorObj.images.forEach((img, index) => {
        const image = img.src;
        const imageId = img.id;
        const imageAspectRatio = img.aspect_ratio;
        let isVideo = false;
        if (index == colorObj.images.length - 1) return; // doesn't include the last image
        if (img.alt == "featured" || img.alt == "featured mobile") return;
        if (
          img.alt.indexOf("youtube.com/embed") > -1 ||
          img.alt.indexOf("player.vimeo.com") > -1
        )
          isVideo = true;


          imageContent = `
          ${imageContent}
          <span data-image-id="${imageId}" data-color-id="${colorId}" class="Product__SlideshowNavImage ${
          isVideo ? "Product__SlideshowNavImage--video" : ""
        } AspectRatio ${
          index == 0 ? "is-selected" : ""
        }" style="--aspect-ratio: ${imageAspectRatio}">
            <img data-src="${image}" class="Image--lazyLoad" height="160px" width="160px" style="height: 160px; width: 160px;">
            ${
              isVideo
                ? `<button type="button" class="Product__SlideshowNavPlay" data-action="play-video" aria-label="">Play</button>`
                : ""
            }
          </span>
        `;

      });

      colorObj.images.forEach((img, index) => {
        const imageAlt = img.alt;
        const imageId = img.id;
        const imageSrc = img.src;
        const imageAspectRatio = img.aspect_ratio;
        const imageWidth = img.width;
        const imageHeight = img.height;
        img.selected_or_first_available_variant_image;
        const paddingBottomCalculation = 100.0 / imageAspectRatio;
        let isVideo = false;
        let initial_image_id = img.featured_image_id;

        if (
          img.alt == "featured" ||
          img.alt == "featured mobile" ||
          index == colorObj.images.length - 1
        )
          return; // doesn't include the last image
        if (
          img.alt.indexOf("youtube.com/embed") > -1 ||
          img.alt.indexOf("player.vimeo.com") > -1
        )
          isVideo = true;

        if (isVideo) {
          slideShowImageContent = `
        <div style="margin-bottom: -6px;" >
          <iframe class="rq-iframe-set-mob-ipad" src="${imageAlt}?autoplay=1&loop=1&showinfo=0&controls=1&rel=0&modestbranding=1" width='100%' height='760' frameborder="0" allowfullscreen></iframe>
          <div class="rq-video-wrap__grippy"></div>
          <div class="rq-video-wrap__grippy2"></div>
        </div>
        `;
        } else {
          slideShowImageContent = `
          <div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: ${paddingBottomCalculation}%; --aspect-ratio: ${imageAspectRatio}">

            <img class="Image--lazyLoad Image--fadeIn"
              ${
                initial_image_id == imageId
                  ? `src="${imageSrc}" style="height: 250px; width: 250px;`
                  : ""
              }
              data-src="${imageSrc}"
              data-widths="[200,400,600,700,800,900,1000,1200,1400,1600]"
              data-sizes="auto"
              data-expand="-100"
              alt="${imageAlt}"
              data-max-width="${imageWidth}"
              data-max-height="${imageHeight}"
              data-original-src="${imageSrc}">

            <span class="Image__Loader"></span>

            <noscript>
              <img src="${imageSrc}" alt="${imageAlt}" style="width: 800px; height: 800px;">
            </noscript>
          </div>
        `;
        }

        slideshowImages = `
        ${slideshowImages}
        <div id="Image${imageId}" data-product-id="${productId}"  data-product-handle="${productHandle}" class="Product__SlideItem Product__SlideItem--${
        isVideo ? "video" : "image"
      } Carousel__Cell ${imageId == initial_image_id ? "is-selected" : ""}"
        ${
          isVideo
            ? `data-action="open-modal" aria-controls="modal-video-${imageId}`
            : `data-image-position-ignoring-video=${index}`
        } data-image-position="${index}"
        data-image-id="${imageId}">
          ${slideShowImageContent}
        </div>
      `;
      });
    });

    document.dispatchEvent(new CustomEvent("swatches:loaded"));
    colorToggle();
    // console.log('here ');
    if (window.theme.template == 'product' && window.innerWidth < 768) {
      const swiper = new Swiper('.mobile-swatch-container', {
        speed: 1000,
        slidesPerView: 3.5,
        spaceBetween: 20,
        loop: false,
        observer: true
      });
    }
  });

  // Load Curalate
  if (window.crl8) {
    crl8.ready(function () {
      crl8.createExperience("product");
    });
  }
};

document.addEventListener("DOMContentLoaded", colorSwatchesInit);


// For adding correct var to cart
document.querySelectorAll('.size-value').forEach(option => option.addEventListener('click', (e) => {
  let optionPosition = option.getAttribute('data-option-index');
  let optionValue = option.getAttribute('data-value');
  let foundVar = '';
  try {
    foundVar = document.querySelector(`.hidden-vars .prod-var[data-option${optionPosition}='${optionValue}']`);
    let varID = foundVar.getAttribute('data-var-id');
    document.querySelector('.product-form__var-input').value = varID;
    // console.log('window.SwymProductInfo.currentVariant ', window.SwymProductInfo.currentVariant);
    window.SwymProductInfo.currentVariant = varID;
    window.triggerSwymVariantEvent(varID)
    // console.log('window.SwymProductInfo.currentVariant ', window.SwymProductInfo.currentVariant);
  } catch (error) {
    console.log('error ', error);
    // window.alert('Please make another selection');
  }
}));



/*
if (document.querySelector('.product')) {
  let lastKnownScrollPosition = 0;
  let ticking = false;
  let targetDivForScrollEnd = document.querySelector('.product__media-wrapper').getBoundingClientRect();
  let targetDivForScrollEndOffset = targetDivForScrollEnd.top;
  let scrollPointToEndAt = document.querySelector('.product__media-wrapper').offsetHeight - targetDivForScrollEndOffset;
  scrollPointToEndAt = scrollPointToEndAt / 2;

  function doSomething(scrollPos) {
    var bodyRect = document.body.getBoundingClientRect(),
      elemRect = document.querySelector('.product').getBoundingClientRect(),
      offset = elemRect.top - bodyRect.top - 100;


    console.log('OFFSET ', offset, scrollPointToEndAt);

    if (scrollPos >= offset) {
      if (!document.querySelector('.product').classList.contains('sticky-photos')) {
        document.querySelector('.product').classList.add('sticky-photos');
      }
    } else {
      if (document.querySelector('.product').classList.contains('sticky-photos')) {
        document.querySelector('.product').classList.remove('sticky-photos');
      }
    }
    if (scrollPos > scrollPointToEndAt) {
      console.log('end here', scrollPointToEndAt);
      if (document.querySelector('.product').classList.contains('sticky-photos')) {
        document.querySelector('.product').classList.remove('sticky-photos');
        // document.querySelector('.product').classList.add('sticky-photos-end');
      }
    }
    console.log('scrollPos:', scrollPos);
  }

  document.addEventListener('scroll', function(e) {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function() {
        doSomething(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });
} */
